class GameLandingDescription extends HTMLElement {
  connectedCallback() {
    const details = this.querySelector('details');
    details?.addEventListener('toggle', this.loadDescription);
    if (details?.open) this.loadDescription({ target: details });
  }

  disconnectedCallback() {
    this.querySelector('details')?.removeEventListener('toggle', this.loadDescription);
  }

  loadDescription = (event) => {
    if (!event.target.open) return;
    const template = this.querySelector('template');
    if (!template) return;

    const content = template.content.cloneNode(true);
    for (const image of content.querySelectorAll('img')) {
      image.loading = 'lazy';
      image.decoding = 'async';
    }
    this.querySelector('[data-description-content]').append(content);
    template.remove();
  };
}

customElements.define('game-landing-description', GameLandingDescription);

class GamePaymentOptions extends HTMLElement {
  observer = new MutationObserver(() => this.updateCheckout());
  pendingSelection = null;
  selectionFailed = false;

  connectedCallback() {
    this.form = this.closest('form');
    this.form.addEventListener('submit', this.guardSelection, true);
    this.section = this.closest('.shopify-section');
    this.section.addEventListener('shopify:product:select', this.variantChanged);
    this.addEventListener('click', this.checkout);
    this.observer.observe(this, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-disabled'],
    });
    this.updateCheckout();
  }

  disconnectedCallback() {
    this.form.removeEventListener('submit', this.guardSelection, true);
    this.observer.disconnect();
    this.section.removeEventListener('shopify:product:select', this.variantChanged);
    this.removeEventListener('click', this.checkout);
  }

  variantChanged = async (event) => {
    if (!this.closest('.product-details').contains(event.target)) return;
    const pending = event.promise;
    this.pendingSelection = pending;
    this.selectionFailed = false;
    this.updateCheckout();
    try {
      await pending;
      await Promise.resolve();
    } catch {
      if (this.pendingSelection !== pending) return;
      this.selectionFailed = true;
      for (const button of this.section.querySelectorAll('.product-details [ref="addToCartButton"], sticky-add-to-cart [ref="addToCartButton"]')) {
        button.disabled = true;
      }
      this.updateCheckout();
      return;
    }
    if (this.pendingSelection !== pending) return;
    this.pendingSelection = null;
    this.updateCheckout();
  };

  updateCheckout() {
    const link = this.querySelector('a.shopify-payment-button__more-options');
    const button = this.querySelector('[data-buy-now]');
    const note = this.querySelector('[data-payment-note]');
    if (!button || !note) return;
    button.hidden = !link;
    button.disabled = Boolean(this.pendingSelection) || !link || link.getAttribute('aria-disabled') === 'true';
    note.hidden = !link;
    this.toggleAttribute('data-checkout-ready', Boolean(link));
    this.toggleAttribute('data-selection-pending', Boolean(this.pendingSelection));
    this.toggleAttribute('data-selection-error', this.selectionFailed);
    this.querySelector('[data-variant-error]')?.toggleAttribute('hidden', !this.selectionFailed);
  }

  guardSelection = (event) => {
    if (!this.selectionFailed) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  checkout = (event) => {
    if (this.pendingSelection || !event.target.closest('[data-buy-now]')) return;
    const link = this.querySelector('a.shopify-payment-button__more-options');
    if (!link || link.getAttribute('aria-disabled') === 'true') return;
    if (!this.closest('form').reportValidity()) return;
    link.click();
  };
}

customElements.define('game-payment-options', GamePaymentOptions);
